import { injectGlobal } from 'styled-components';

injectGlobal`
 @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700&display=swap');
`;
